import { render, staticRenderFns } from "./classSignRecordDetail.vue?vue&type=template&id=54fddd3b&scoped=true&"
import script from "./classSignRecordDetail.vue?vue&type=script&lang=js&"
export * from "./classSignRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./classSignRecordDetail.vue?vue&type=style&index=0&id=54fddd3b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fddd3b",
  null
  
)

export default component.exports